import { render, staticRenderFns } from "./RequestResetPassword.vue?vue&type=template&id=f37cf83c&scoped=true&"
import script from "./RequestResetPassword.vue?vue&type=script&lang=js&"
export * from "./RequestResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./RequestResetPassword.vue?vue&type=style&index=0&id=f37cf83c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37cf83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f37cf83c')) {
      api.createRecord('f37cf83c', component.options)
    } else {
      api.reload('f37cf83c', component.options)
    }
    module.hot.accept("./RequestResetPassword.vue?vue&type=template&id=f37cf83c&scoped=true&", function () {
      api.rerender('f37cf83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Auth/RequestResetPassword.vue"
export default component.exports